import { Checkbox } from 'antd'
import React, { useEffect, useState } from 'react'
import { FixedSizeList } from 'react-window'
import SearchInput from '../../FilterSearchInput'

const VirtualizedCheckboxGroup = ({
  options,
  value,
  setValue,
  valueParam = 'value',
  labelParam = 'label',
  setStateName,
  filterId,
  searchNotNeeded = false,
  setDegreeSearch,
  parentId,
  saveById = false,
  check,
}) => {
  const [filter, setFilter] = useState('')

  useEffect(() => {
    setFilter('')
  }, [parentId])

  useEffect(() => {
    setFilter('')
  }, [check])

  const handleCheckboxChange = (optionValue, id) => {
    const newValue = [...value]

    const index = newValue.indexOf(saveById ? id : optionValue)

    if (index === -1) {
      newValue.push(saveById ? id : optionValue)
    } else {
      newValue.splice(index, 1)
    }

    handleChange(newValue)

    if (filterId) {
      setStateName(prevState => {
        if (prevState?.includes(id)) {
          return prevState.filter(item => item !== id)
        } else {
          return [...prevState, id]
        }
      })
    }
  }

  const filteredOptions = options?.filter(
    option =>
      option?.[labelParam]?.toLowerCase()?.includes(filter.toLowerCase()) ||
      option?.[valueParam]?.toLowerCase()?.includes(filter.toLowerCase())
  )
  const handleChange = newValue => {
    setValue(newValue)
  }

  const search = e => {
    setFilter(e.target.value)
    setDegreeSearch(e.target.value)
  }

  return (
    <div>
      {!searchNotNeeded && (
        <SearchInput
          placeholder="Search by keyword"
          value={filter}
          onChange={search}
        />
      )}
      <FixedSizeList
        height={200}
        itemCount={filteredOptions?.length}
        itemSize={50}
        style={{ marginTop: searchNotNeeded ? 20 : 0 }}
      >
        {({ index, style }) => (
          <div style={style}>
            <Checkbox
              checked={
                value?.indexOf(
                  filteredOptions[index][saveById ? valueParam : labelParam]
                ) !== -1
              }
              onChange={() =>
                handleCheckboxChange(
                  filteredOptions[index][labelParam],
                  filteredOptions[index][valueParam]
                )
              }
            >
              {filteredOptions[index][labelParam]}
            </Checkbox>
          </div>
        )}
      </FixedSizeList>
    </div>
  )
}

export default VirtualizedCheckboxGroup
